const KEY = "fg_attribution";
const UTM = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

export function captureAttribution() {
  if (localStorage.getItem(KEY)) return;
  const params = new URLSearchParams(window.location.search);
  const attr = {};
  UTM.forEach((k) => { if (params.get(k)) attr[k] = params.get(k); });
  if (document.referrer && !document.referrer.includes(window.location.host)) attr.referrer = document.referrer;
  attr.landing_page = window.location.pathname;
  localStorage.setItem(KEY, JSON.stringify(attr));
}

export function getAttribution() {
  try { return JSON.parse(localStorage.getItem(KEY) || "{}"); } catch { return {}; }
}
